import React, { useState, useEffect } from "react";
import "./styles.css";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { getCurrentUserReports } from '../../db';

const Header = () => {
  const [optometristRole, setOptometristRole] = useState(null);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    // Get the optometrist role from localStorage
    const role = localStorage.getItem("optometrist_role");
    setOptometristRole(role);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  // Check for pending data count
  useEffect(() => {
    const checkPendingCount = async () => {
      try {
        const pendingReports = await getCurrentUserReports();
        setPendingCount(pendingReports.length);
      } catch (error) {
        console.error('Error checking pending count:', error);
      }
    };
    
    checkPendingCount();
    // Check every 30 seconds
    const interval = setInterval(checkPendingCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        setDeferredPrompt(null);
        setShowInstall(false);
      });
    }
  };
  
  return (
    <div className="headerBar">
        <div style={{display: "flex", gap: "2vw"}}>
            {/* Only show Dashboard if role is not Ophthalmologist */}
            {optometristRole !== "Ophthalmologist" && (
              <Typography component={Link} to="/dashboard" className={`${window.location.pathname === '/dashboard' ? "activeLinkText" : "navLinkText1"}`}>Dashboard</Typography>
            )}
            <Typography component={Link} to="/patientrecord" className={`${window.location.pathname === '/patientrecord' ? "activeLinkText" : "navLinkText1"}`}>Patient Records</Typography>
            {optometristRole !== "Ophthalmologist" && (
            <Typography component={Link} to="/syncdata" className={`${window.location.pathname === '/syncdata' ? "activeLinkText" : "navLinkText1"}`}>
              Sync Data{pendingCount > 0 && ` (${pendingCount})`}
            </Typography>
            )}
        </div>
        <div className="headerBarAccountDiv" style={{display: "flex", justifyItems: "center", alignItems: "center", gap: "10px"}} >
            <Typography component={Link} to="/account" className={`${window.location.pathname === '/account' ? "activeLinkText" : "navLinkText2"}`}  style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span>Account</span>
              {/* <img src={Account} alt="Account Icon" /> */}
              <AccountCircleOutlinedIcon className={`${window.location.pathname === '/account' ? "activeLinkText" : "navLinkText2"}`} sx={{ fontSize: "xx-large" }}/>
            </Typography>
            {showInstall && (
              <button onClick={handleInstallClick} style={{marginLeft: 10, padding: '0.5em 1em', background: '#0D1E83', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 16}}>
                Install App
              </button>
            )}
        </div>
    </div>
  )
}

export default Header